// React
import { memo } from "react";

// Tipovi
import { PricingStepIntroProps } from "./types";

/**
 * Naslov i opis koraka — isti prikaz kao u čarobnjaku za unos vozila: centrirano iznad
 * obrasca, da se na svakom koraku vidi što se ovdje unosi i zašto.
 */
const PricingStepIntro: React.FC<PricingStepIntroProps> = (props: PricingStepIntroProps) => {
  const { title, description } = props;

  return (
    <div className="px-4 pt-8">
      <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">{title}</h1>
      <p className="text-center text-md text-slate-600 mb-4 max-w-2xl mx-auto">{description}</p>
    </div>
  );
};

export default memo(PricingStepIntro);
